// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MatTooltip } from '@angular/material/tooltip';


@Component({
    selector: 'app-get-password',
    templateUrl: './get-password.component.html',
    styleUrls: ['./get-password.component.scss'],
    standalone: false
})

export class GetPasswordComponent implements OnInit {
  @ViewChild('tooltip') tooltip: MatTooltip;
  password_required_title_text;
  password_required_text;
  password_placeholder_text;
  cancel_text = 'Cancel';
  submit_text = 'Submit';
  capsOn: boolean;
  passwordInputIsFocused = false;

  passwordForm: UntypedFormGroup;

  constructor( public dialogRef: MatDialogRef<GetPasswordComponent>,
               private formBuilder: UntypedFormBuilder,
               private translate: TranslateService,
               @Inject(MAT_DIALOG_DATA) public data: any) {
    this.passwordForm = this.formBuilder.group({
            password: ['', Validators.required]
    });
    this.password_required_title_text = data.title;
    this.password_required_text = data.info;
    this.password_placeholder_text = data.fieldLabel;
    this.translate.get( ['CANCEL', 'SUBMIT']).subscribe( vals => {
          this.cancel_text = vals['CANCEL'];
          this.submit_text = vals['SUBMIT'];
    });
  }

  ngOnInit(): void {
  }

  cancel() {
    this.dialogRef.close();
  }

  onsubmit() {
    this.dialogRef.close(this.passwordForm.value.password);
  }

  onCapsLockChanged(event: boolean) {
    this.capsOn = event && this.passwordInputIsFocused;
  }

  passwordFocus() {
    this.passwordInputIsFocused = true;
  }

  passwordBlur() {
    this.passwordInputIsFocused = false;
  }

}
